import { load_image_from } from 'src/helpers/interface_helpers';
import type { AvatarColorVariantTypes } from '@Shelly/shelly-design-system';

type ScopeType = 'room' | 'account' | 'by_device_account';

export type ConsumptionStores = Record<
	ScopeType,
	{ all: Record<string, unknown>; power_data: Record<string, unknown> }
>;

export type ConsumptionStoresInput = {
	rooms: Record<string | number, unknown>;
	devices: Record<string | number, unknown>;
	consumptionRooms: Record<string | number, unknown>;
	consumptionDevice: Record<string | number, unknown>;
	consumptionByDeviceAccount: Record<string | number, unknown>;
};

/** Mirrors the store wiring in ConsumptionCurrent.svelte */
export const buildConsumptionStores = ({
	rooms,
	devices,
	consumptionRooms,
	consumptionDevice,
	consumptionByDeviceAccount,
}: ConsumptionStoresInput): ConsumptionStores => ({
	account: { all: rooms, power_data: consumptionRooms },
	room: { all: devices, power_data: consumptionDevice },
	by_device_account: { all: devices, power_data: consumptionByDeviceAccount },
});

const filterByScope = (entry: { room_id?: number }, scope: ScopeType, roomID: string | number) => {
	if (scope === 'room') {
		return entry.room_id === roomID;
	}
	return true;
};

export const getRealtimeConsumptionMap = (
	stores: ConsumptionStores,
	roomID: string | number = '',
	scope: ScopeType = 'account',
) => {
	const scopeStore = stores[scope];
	const allEntries = scopeStore?.all ?? {};
	const powerData = scopeStore?.power_data ?? {};

	return Object.values(allEntries)
		.filter((entry) => filterByScope(entry as { room_id?: number }, scope, roomID))
		.reduce(
			(
				filtered: Record<
					string | number,
					{
						in_power?: number;
						ex_power?: number;
						_power?: number;
						title: string;
						id: number | string;
						position?: number;
						image?: string;
						backgroundColor?: AvatarColorVariantTypes;
						icon?: string;
						room_id?: number;
					}
				>,
				v: {
					id: number;
					name: string;
					image?: string;
					backgroundColor?: AvatarColorVariantTypes;
					icon?: string;
					room_id?: number;
					position?: number;
				},
			) => {
				const powerEntry = powerData[v.id];
				if (typeof powerEntry !== 'undefined') {
					filtered[v.id] = {
						...(powerEntry as object),
						title: v.name,
						id: v.id,
						position: (allEntries[v.id] as { position?: number })?.position,
						image: v.image ? load_image_from(v.image) : undefined,
						backgroundColor: v.backgroundColor,
						icon: v.icon,
						room_id: v.room_id,
					};
				} else if (scope === 'account') {
					filtered[v.id] = {
						in_power: 0,
						ex_power: 0,
						_power: 0,
						title: v.name,
						id: v.id,
						position: (allEntries[v.id] as { position?: number })?.position,
					};
				}
				return filtered;
			},
			{},
		);
};
